import {AXIS_LABEL, AXIS_LINE_STYLE, NUMBER_FONT_FAMILY, TEXT_FONT_FAMILY} from './chartStyle'

export default {
  name: 'BaseFactorChart',
  props: {
    factorGroup: {
      required: true,
      type: Object
    },
    data: {
      required: true,
      type: Array
    },
    dataTimes: {
      required: true,
      type: Array
    },
    unitProp: {
      required: true,
      type: String
    }
  },
  computed: {
    filterFactors () {
      return this.factorGroup.children
    }
  },
  methods: {
    setSeries (chartOpt, unitMap) {},
    render () {
      let chartOpt = this.getChartOpt()
      this.setSeries(chartOpt, this.getUnitMap(chartOpt))
      this.renderChart(chartOpt)
    },
    getChartOpt () {
      let {factorGroup, dataTimes, unitProp, filterFactors} = this
      let oldChartOpt = this.getChart().getOpt()
      let legendSelected = {}

      if (oldChartOpt) {
        legendSelected = oldChartOpt.legend[0].selected
      }

      let ratio = Math.min(100, 100 / dataTimes.length * 100)

      return this.setYAxis({
        title: {
          text: factorGroup.name,
          left: 'center',
          textStyle: {
            fontFamily: TEXT_FONT_FAMILY
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {
          trigger: 'axis',
          appendToBody: true
        },
        legend: {
          top: 27,
          left: 'center',
          width: '75%',
          type: 'scroll',
          selected: legendSelected
        },
        grid: [{
          top: 75,
          right: 40,
          bottom: 45,
          left: 30,
          containLabel: true
        }],
        xAxis: [{
          type: 'category',
          data: dataTimes,
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: TEXT_FONT_FAMILY
            // rotate: 90
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          }
        }],
        dataZoom: [{
          type: 'inside',
          start: 0,
          end: ratio,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5
        }, {
          type: 'slider',
          start: 0,
          end: ratio,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5,
          // height: 39,
          bottom: 9,
          left: 'center',
          handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '70%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 4,
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          },
          // dataBackground: {
          //   areaStyle: '#E4F0FF'
          // }
          fillerColor: 'rgba(228, 240, 255, .6)',
          borderColor: '#E4F0FF'
        }]
      }, filterFactors, unitProp)
    },
    setYAxis (chartOpt, filterFactors, unitProp) {
      let units = [...new Set(filterFactors.map(factor => factor[unitProp]))]

      chartOpt.yAxis = units.map((unit, index) => ({
        name: unit,
        type: 'value',
        nameGap: 10,
        offset: Math.max(0, index - 1) * 40,
        axisLine: {
          show: true,
          lineStyle: AXIS_LINE_STYLE
        },
        splitLine: {
          show: index === 0
        },
        axisLabel: {
          ...AXIS_LABEL,
          fontFamily: NUMBER_FONT_FAMILY
        }
      }))

      return chartOpt
    },
    getUnitMap (chartOpt) {
      return chartOpt.yAxis.reduce((map, yAxis, index) => {
        map[yAxis.name] = index
        return map
      }, {})
    },
    renderChart (chartOpt) {
      let chart = this.getChart()
      chart.clear()
      chart.resize()
      chart.setOpt(chartOpt)
    },
    getChart () {
      return this.$refs.chart
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Data/FactorCharts/BaseFactorChart.js